import getters from 'shared/helpers/vuex/getters'

export default {
    ...getters
}


// WEBPACK FOOTER //
// ./src/enterprise/vuex/getters.js